import { formatMoney, template } from '@belong/common';
import { Text } from '@belong/ui';
import { STRINGS } from './strings';
import { ownProCopyTokens } from './utils';

type Props = {
  count: number;
  quotePending: boolean;
  neverExceedTotal?: number;
};

export function OwnProItemsSummary({
  count,
  quotePending,
  neverExceedTotal,
}: Props) {
  if (count === 0) return null;

  const showExclusion = quotePending && typeof neverExceedTotal === 'number';

  const tokens = ownProCopyTokens(count);
  const title = template(STRINGS.summary.title, tokens);

  return (
    <div className="rounded border border-solid border-gray bg-light-gray p-sm">
      <Text fontWeight="semibold" className="mb-xs">
        {title}
      </Text>
      <Text variant="p1">
        {showExclusion ? (
          <>
            {STRINGS.summary.quotePendingPrefix}
            <Text as="span" variant="p1" fontWeight="semibold">
              {template(STRINGS.summary.quotePendingEmphasis, {
                ...tokens,
                total: formatMoney(neverExceedTotal, 'DOLLARS_WITH_CENTS'),
              })}
            </Text>
            {STRINGS.summary.quotePendingRest}
          </>
        ) : (
          template(STRINGS.summary.neutral, tokens)
        )}
      </Text>
    </div>
  );
}
